import React, {
  useCallback,
  useEffect,
  useState,
  useContext,
  useReducer,
  useMemo,
  useRef,
} from 'react';
import 'antd/dist/antd.css';
import { Avatar, Button, Card, Form, Skeleton } from 'antd';
import '../chatComponent/chat.css';

const { Meta } = Card;
const PersonalChatCards = ({ props }: any) => {
  const [previousCard, setPreviousCard] = useState<{ classList: any }>({ classList: null });
  const [loading, setLoading] = useState(false);
  //Хранилище данных для карточек личного чаты
  const [sessionPersonal, setSessionPersonal] = useState([]);

  const propsTakeFromChat = useMemo(() => {
    if (props.sessionPersonal !== undefined) {
      setSessionPersonal((sessionPersonal) => props.sessionPersonal);
    }
  }, [props]);
  //Для подсвета выбранной карточки
  const changeClassNameFunc = (element: any) => {
    const thisElement: any = document.getElementById('PersonalCard' + element);
    if (previousCard.classList === null) {
      setPreviousCard((previousCard) => thisElement);
      thisElement.classList.add('chat-selecter__active');
    } else {
      previousCard.classList.remove('chat-selecter__active');
      thisElement.classList.add('chat-selecter__active');
      setPreviousCard((previousCard) => thisElement);
    }
  };
  /////////////////////////////////
  return (
    <>
      <div>Личные чаты:</div>
      {sessionPersonal?.map((item: any) => {
        return (
          <Card
            id={'PersonalCard' + item.receiver_id}
            key={item.receiver_name + item.receiver_id}
            style={{
              width: 300,
              marginTop: 16,
              cursor: 'pointer',
            }}
            onClick={(e: any) => {
              changeClassNameFunc(item.receiver_id);
              props.setNameFriendFunc(item.receiver_name);
              props.openPersonal({
                session_id: item.receiver_id,
                is_group: false,
              });
            }}
          >
            <Skeleton loading={loading} avatar active paragraph={{ rows: 0 }}>
              <Meta
                avatar={<Avatar src={item.image} />}
                title={item.receiver_name}
                description={item.unread_msg}
              />
            </Skeleton>
          </Card>
        );
      })}
    </>
  );
};

export default PersonalChatCards;
